export default (_this) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: _this.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 150,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'taskNo',
    align: 'center',
    minWidth: 140,
    title: _this.$l('form_label_task_no') || '盘点任务单号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'taskRangeFlagName',
    align: 'center',
    minWidth: 100,
    title: _this.$l('form_label_taskRangeFlag') || '任务范围',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'adjustFlag',
    align: 'center',
    minWidth: 100,
    title: _this.$l('form_label_adjustFlag') || '核对标志',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: { default: 'adjustFlagInfo' }
  },
  // {
  //   field: 'taskExplain',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 200,
  //   title: _this.$l('form_label_taskExplain') || '任务说明',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis'
  // },
  {
    field: 'taskStatus',
    align: 'center',
    minWidth: 100,
    title: _this.$l('form_label_taskStatus') || '任务状态',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: { default: 'status' }
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: _this.$l('INDEX.creator') || '创建人',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    headerAlign: 'center',
    field: 'createDate',
    title: _this.$l('INDEX.bill_time_create_time') || '创建时间',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: _this.$l('INDEX.table_label_modified_by') || '修改人',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    headerAlign: 'center',
    field: 'modifyDate',
    title: _this.$l('INDEX.bill_time_modify_time') || '修改时间',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true
  },
  {
    headerAlign: 'center',
    field: 'auditByName',
    title: _this.$l('form_label_auditByName') || '审核人名称',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'auditDate',
    align: 'center',
    title: _this.$l('form_label_auditDate') || '审核时间',
    minWidth: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  }
]
